/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { tableSearchInput } from '../common/filter-input';

/**
 * Adds a search filter to the terminal list table
 * 
 * @param tableObject void
 */
export const terminalListFilter = ( tableObject: TabulatorFull ): void => {
  const terminalListSort = document.querySelector('#aafp_terminal-list-sort') as HTMLInputElement;
  tableSearchInput(terminalListSort, tableObject);
};